import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import ReactSelect from 'react-select';
import DatePicker from 'react-datepicker';

const generateData = (length = 12) => {
  const value = [];
  for (let i = 1; i <= length; i++) {
    const data = { value: i, label: i };
    value.push(data);
  }
  return value;
};

const LeadSource = () => {
  const [score, setScore] = useState(null);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);

  return (
    <Card className="mb-3">
      <Card.Header>
        <Card.Title className="fw-medium">
          Lead Source <span className="text-400">(Optional)</span>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={12}>
            <Row>
              <Form.Group as={Col} md={6} className="mb-3">
                <Form.Label>Source</Form.Label>
                <ReactSelect
                  required
                  closeMenuOnSelect={true}
                  options={generateData(100)}
                  placeholder=""
                  classNamePrefix="react-select"
                  value={score}
                  onChange={value => setScore(value)}
                />
                <Form.Control.Feedback type="invalid">
                  Required
                </Form.Control.Feedback>
              </Form.Group>
              <Col md={6} />
              <Form.Group
                as={Col}
                md="4"
                className="mb-3 mb-md-0"
                controlId="Consented_Date"
              >
                <Form.Label>
                  Date<span className="text-danger">*</span>
                </Form.Label>
                <DatePicker
                  required
                  selected={date}
                  onChange={date => setDate(date)}
                  className="form-control"
                  placeholderText="DD/MM/YYYY"
                  timeIntervals={5}
                  dateFormat="dd/MMyyyy"
                  fixedHeight
                />

                <Form.Control.Feedback type="invalid">
                  Required
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="Consented_Time">
                <Form.Label>
                  Time<span className="text-danger">*</span>
                </Form.Label>
                <DatePicker
                  required
                  selected={time}
                  onChange={date => setTime(date)}
                  className="form-control"
                  placeholderText="00:00:00"
                  timeIntervals={1}
                  dateFormat="h:mm aa"
                  showTimeSelect
                  showTimeSelectOnly
                />

                <Form.Control.Feedback type="invalid">
                  Required
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default LeadSource;
